import { Storage, TranslatorContext } from 'react-jhipster';

import { setLocale } from 'app/shared/reducers/locale';

TranslatorContext.setDefaultLocale('en');
TranslatorContext.setRenderInnerTextForMissingKeys(false);

export const languages: any = {
  en: { name: 'English' },
  bn: { name: 'বাংলা' },
  hi: { name: 'हिंदी' },
  mr: { name: 'मराठी' },
  pa: { name: 'ਪੰਜਾਬੀ' },
  ta: { name: 'தமிழ்' },
  te: { name: 'తెలుగు' },
  // jhipster-needle-i18n-language-key-pipe - JHipster will add/remove languages in this object
};

export const locales = Object.keys(languages).sort();

export const registerLocale = store => {
  store.dispatch(setLocale(Storage.session.get('locale', 'en')));
};
